function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "User");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.8,52.4H1.2v-2c0-10.9,8.5-19.7,18.9-19.7h10.1l0,0c3.3,0,6.6,0.9,9.5,2.7l-2.1,3.4     c-2.2-1.4-4.8-2.1-7.4-2.1l0,0H20.1c-7.6,0-13.8,6-14.8,13.7h21.5C26.8,48.4,26.8,52.4,26.8,52.4z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.8,27.8C18.2,27.8,12,21.6,12,14S18.2,0.1,25.8,0.1S39.6,6.3,39.6,14S33.4,27.8,25.8,27.8z M25.8,4.1     c-5.4,0-9.8,4.4-9.8,9.8s4.4,9.8,9.8,9.8s9.8-4.4,9.8-9.8S31.2,4.1,25.8,4.1z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "40.9,53.1 32.3,44.9 35.1,42 40.9,47.6 54,35.1 56.7,38 "
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 57 54",
    fill: "#00dacc",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.98e10b84.svg";
export { ForwardRef as ReactComponent };